import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-for-providers',
  templateUrl: './users-for-providers.component.html',
  styleUrls: ['./users-for-providers.component.scss']
})
export class UsersForProvidersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
